import { apiFetch, type TokenStore } from './client.ts';

/** Platform-wide maintenance/outage banner (platform_announcement.create / .clear). */
export interface ActiveAnnouncement {
  id: string;
  message: string;
  startsAt: number;
  endsAt: number;
}

/** Public — no auth required; safe to call before a session exists. */
export async function getActiveAnnouncement(store: TokenStore): Promise<ActiveAnnouncement | null> {
  return apiFetch<ActiveAnnouncement | null>('/platform-announcements/active', {}, store);
}

/** platform_admin only — every uncleared row, not just the one in its active window. */
export async function listPendingAnnouncements(store: TokenStore): Promise<ActiveAnnouncement[]> {
  return (await apiFetch<{ announcements: ActiveAnnouncement[] }>('/admin/platform-announcements', {}, store)).announcements;
}

export async function createAnnouncement(
  input: { message: string; startsAt: number; endsAt: number },
  store: TokenStore,
): Promise<ActiveAnnouncement> {
  return apiFetch<ActiveAnnouncement>(
    '/admin/platform-announcements',
    { method: 'POST', body: JSON.stringify(input) },
    store,
  );
}

export async function clearAnnouncement(id: string, store: TokenStore): Promise<void> {
  await apiFetch<Record<string, never>>(
    `/admin/platform-announcements/${encodeURIComponent(id)}`,
    { method: 'DELETE' },
    store,
  );
}
